import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"

export default class extends Controller {
  static targets = ["settingsLink", "warningIcon"]

  connect() {
    // In case the user is on a Turbo preview of the page,
    // don't check the connection with Gmail and Outlook.
    if (NavigationHelper.pageIsPreview()) {
      return
    }

    this.checkEmailAccountsConnection()
  }

  checkEmailAccountsConnection() {
    fetch("/users/email-accounts", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((response) => {
        let disconnectedAccounts = []

        response.accounts.forEach(function (account) {
          if (account.connected === false) {
            disconnectedAccounts.push({ email: account.email, provider: account.provider })
          }
        })

        if (disconnectedAccounts.length === 0) {
          this.warningIconTarget.classList.add("d-none")
          this.warningIconTarget.removeAttribute("data-bs-toggle")
          return
        }

        let iconTooltipTitle

        if (disconnectedAccounts.length === 1) {
          iconTooltipTitle = `The connection with ${App.capitalizeFirstLetter(disconnectedAccounts[0].provider)} for ${disconnectedAccounts[0].email} has expired. Please reconnect your account.`
        } else {
          iconTooltipTitle = `The connections for ${disconnectedAccounts.map((acc) => acc.email).join(" and ")} have expired. Please reconnect your accounts.`
        }

        this.settingsLinkTarget.href += "?tab=email-accounts"

        this.warningIconTarget.setAttribute("title", iconTooltipTitle)
        this.warningIconTarget.setAttribute("data-bs-toggle", "tooltip")
        this.warningIconTarget.classList.remove("d-none")

        App.tooltip(".submenu__warning-icon")
      })
  }
}
